export const FEEDBACKS = [
  {
    // image: "",
    name: "Victor Payan",
    jobPosition: "COO @ Ermeo",
    feedback:
      "We've been working closely with a dedicated team to build our mobile app as well an SDK with SQLites Storage and most excitingly support for deploying the mobile app to our customers.",
  },
]
